import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import "../App.css";

const Footer = () => {
  const footerRef = useRef(null);

  useEffect(() => {
    gsap.from(footerRef.current, {
      opacity: 0,
      y: 80,
      duration: 1.2,
      ease: "power3.out",
      delay: 0.2
    });
  }, []);

  return (
  <footer className="footer-container">

<div className="footer-content">

<div className="footer-column">
<h3>Company</h3>
<ul>
<li>About</li>
<li>Pricing</li>
<li>Jobs</li>
<li>Blog</li>
<li>Careers</li>
</ul>
</div>

<div className="footer-column">
<h3>Product</h3>
<ul>
<li>Sales software</li>
<li>Features</li>
<li>Privacy and security</li>
<li>Marketplace</li>
<li>API</li>
</ul>
</div>

<div className="footer-column">
<h3>Help Center</h3>
<ul>
<li>Community</li>
<li>Knowledge Base</li>
<li>Academy</li>
<li>Support</li>
</ul>
</div>

<div className="footer-column download">
<h3>Download</h3>
<p>
Join millions of people who build a fully integrated sales
and marketing solution.
</p>
</div>

</div>

<div className="footer-bottom">
<p>Copyright @2023 Aspire. All Rights Reserved.</p>
<p>Terms & Conditions ~ Privacy Policy</p>
</div>

</footer>
  );
};

export default Footer;